/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { upsertPicklistOptionRequestSchema } from './upsertPicklistOptionRequestSchema';

export const createFieldRequestSchema = z.object({
  afterId: z.int().nullish(),
  archived: z.boolean(),
  beforeId: z.int().nullish(),
  currencyUnit: z.string().nullish(),
  itemTypeAssociationMode: z.enum(['ALL', 'CUSTOM']),
  name: z.string(),
  get picklistOptions() {
    return z.array(upsertPicklistOptionRequestSchema).nullish();
  },
  type: z.enum([
    'CHECKBOX',
    'CURRENCY',
    'DATE',
    'ITEM',
    'LINK',
    'MULTI_CUSTOMER',
    'MULTI_ITEM',
    'MULTI_LINK',
    'MULTI_PICKLIST',
    'MULTI_TEXT',
    'MULTI_USER',
    'MULTILINE_TEXT',
    'NOTE',
    'NUMERIC',
    'PICKLIST',
    'TEXT',
    'USER',
  ]),
});
